import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  Box,
  TextField,
  InputAdornment,
  Typography,
  Avatar,
  Skeleton,
  Container,
  useTheme,
} from "@mui/material";
import { SearchButton } from "../../screens/AddConnections/AddConnections.styles";
import { ReactComponent as SearchIcon } from "../../assests/icons/search_icon.svg";
import CardButton from "../CardButton";
import CardsScrollableContainer from "../../components/CardsScrollableContainer";
import { useGetRequests } from "../../utils/queries";
import { dialogActions } from "../../store/reducers/dialog";
import {
  connectionsApiUrl,
  protocol,
  hostname,
} from "../../utils/config";
import { useTranslation } from "react-i18next";
import ViewSearchConnectionDetilDialog from "../Dialog/ViewSearchConnectionDetailDialog";
import SuccessDialog from "../Dialog/SuccessDialog";
import { ConnectionsToken, ErrorToken, homeToken, laptopMQL } from "../../utils/constant";
import ScrollContainerWrapper from "../ScrollContainerWrapper";

const searchTextfiled = {
  width: "583px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    border: "1px solid #D9D9D9 !important",
    borderRadius: "4px",
    boxShadow: "5px 5px 5px 5px rgba(0, 0, 0, 0.07) !important",
  },
  ".MuiInputBase-input": { color: '#64666A' },
  [laptopMQL]:{
    ".MuiInputBase-input": {
      padding:"1rem 1.4rem 1rem 0.5rem"
    },
    ".search-ico":{
      height:"2.2rem",
      
    }
  },
  "@media only screen and (min-width: 650px) and (max-width: 830px)":{
    width: "590px",
    padding:"0"
  },
  "@media only screen and (max-width: 649px)":{
    width: "35.6rem"
  }
  
};

const SearchListSkelton = () => (
  <>
    {[...Array(12)].map((_, i) => {
      return (
        <Skeleton
          sx={{ width: "35.6rem", height: "15.8rem" }}
          variant="rectangular"
          key={i}
        />
      );
    })}
  </>
);

const Card = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    profileImage,
    name,
    profession,
    secondaryCategory,
    chapterName,
    connectionUser,
  } = props.cardData;
  const theme = useTheme();

  const handleConnectionDetailCard = () => {
    dispatch(dialogActions.setDialogType("searchconnectiondetailcard"));
    dispatch(dialogActions.setRequestId(connectionUser));
    dispatch(dialogActions.setDataObj(props.cardData));
    return;
  };

  return (
    <Box
      sx={{
        width: "35.6rem",
        height: "15.8rem",
        backgroundColor: "#F2F2F2",
        display: "flex",
        flexDirection: "column",
        padding: "2.5rem 2.3rem",
        rowGap: "0.9rem",
        borderRadius: "0.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          columnGap: "2rem",
          width: "100%",
        }}
      >
        <Box
          sx={{ width: "7.8rem", display: "flex", justifyContent: "center" }}
        >
          <Avatar
            alt={`${name} profile image`}
            src={profileImage?`${protocol}${hostname}:443//core-api/public/image/${profileImage}`:`${name}`}
            sx={{ width: "6.5rem", height: "6.5rem" }}
          />
        </Box>

        <Box sx={{ width: "21rem", display: "flex", flexDirection: "column" }}>
          <Typography
            title={name}
            sx={{
              fontSize: "2rem",
              color: "#cf2030",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              cursor: "default",
              whiteSpace: "nowrap"
            }}
          >
            {name}
          </Typography>
          <Typography
            sx={{
              fontSize: "1.4rem",
              color: "#676767",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              cursor: "default",
              textWrap: "wrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              WebkitLineClamp: "2",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
            }}
          >
            {profession && secondaryCategory
              ? `${t(profession)} | ${t(secondaryCategory)}`
              : profession
              ? t(profession)
              : secondaryCategory
              ? t(secondaryCategory)
              : "\u00A0"}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          columnGap: "2rem",
          width: "100%",
        }}
      >
        <Box>
          <CardButton
            value={t(homeToken.Connect)}
            onClickHandler={handleConnectionDetailCard}
          />
        </Box>

        <Box sx={{ width: "21rem" }}>
          <Typography
            sx={{
              fontSize: "1.4rem",
              color: "#cf2030",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              lineHeight: "1.7rem",
              cursor: "default",
            }}
          >
            {chapterName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const SearchList = (searchValue) => {
  const [searchText, setSearchText] = useState(searchValue.searchText);
  const dialogType = useSelector((state) => state.dialog.dialogType);
  const userData = useSelector((state) => state.dialog.dataObj);
  const { t } = useTranslation();
  let [searchParams, setSearchParams] = useSearchParams();
  const getSearchConnections = useGetRequests();
  const [isMakeCall, setIsMakeCall] = useState(false);
  const [connectionList, setConnectionList] = useState([]);
  const [searchFieldError, setSearchFieldError] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if(searchText.trim().length >= 3){
      setIsMakeCall(true);
    }
    else{
      setSearchFieldError(true);
    }
  }, []);

  const callConnectionAPI = () => {
    getSearchConnections.mutate(
      {
        url: `${connectionsApiUrl}search-member?memberKeyword=${searchText}`
      },
      {
        mutationKey: "getSearchConnections",
        onSuccess: (success) => {
          if (success.status === 200) {
            setConnectionList(success.data.content);
          }
        },
        onError: (error) => {
          console.log(" api call error data is ", error);
          alert(t(homeToken.GenericError));
        },
        cacheTime: 0,
      }
    );
  };

  useEffect(() => {
    if (isMakeCall) {
      callConnectionAPI();
    }
  }, [isMakeCall]);

  const searchConnections = () => {
    if (searchText.trim() && searchText.trim().length >= 3) {
      let data = {
        search: searchText.trim(),
      };
      setSearchParams(data);
      callConnectionAPI();
    } else {
      setSearchFieldError(true);
    }
  };

  useEffect(() => {
    if (dialogType === "connectionsuccess") {
      callConnectionAPI();
    }
  }, [dialogType]);

  const getFirstName = () => {
    const name = userData && userData.name.split(" ");
    return name[0].toUpperCase();
  } 

  return (
    <ScrollContainerWrapper>
      <Box
        container
        spacing={2}
        sx={{
          display: "flex",
          marginLeft: "0px",
          marginTop: "0px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box component={"div"} sx={{ p: 5,[laptopMQL]:{pt: 5, pb:1},"@media only screen and (max-width: 830px)":{px:0} }}>
          <Box sx={{ display: "flex", gap: "2.4rem",
                    "@media only screen and (max-width: 830px)":{
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "0.5rem",
                      marginBottom:"1rem"
              }  }}>
            <Box component={"div"}>
              <TextField
                sx={searchTextfiled}
                placeholder={t(homeToken.Search)}
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  setSearchFieldError(false);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon className="search-ico"/>
                    </InputAdornment>
                  ),
                }}
                onKeyDown={e=> {e.key  === 'Enter' && searchConnections()}}
              />
              <Typography
            sx={{
              color: "#cf2030",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              visibility: searchFieldError ? "visible" : "hidden",
              padding: "1rem 2.5rem 0rem 0.5rem",
            }}
          >{t(ErrorToken.SearchLenghtError)}</Typography>
            </Box>
            <Box component={"div"}>
              <SearchButton onClick={searchConnections} disableRipple>{t(homeToken.Search)}</SearchButton>
            </Box>
          </Box>
          
        </Box>
      </Box>
      {/* Started Card from here */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}>
      <CardsScrollableContainer marginTop={"false"} calcHeight="85vh">
        {getSearchConnections.isLoading ? (
          <SearchListSkelton />
        ) : getSearchConnections.isSuccess && connectionList.length >= 1 ? (
          <>
            {connectionList.map((data, index) => (
              <Card key={data.connectionUser} cardData={data} />
            ))}
          </>
        ) : (
          <Typography sx={{
            width:"100%",
            color: "#cf2030",
            textAlign: "center",
            fontWeight:"700",
            animation: "fadeanimation 2s infinite",
            gridColumn:"1/-1",
          }}
          >{t(homeToken.DataNotFound)}</Typography>
        )}
      </CardsScrollableContainer>
      </Box>
      {/* Dialog box code */}
      {dialogType === "searchconnectiondetailcard" && (
        <Container maxWidth="false" disableGutters>
          <ViewSearchConnectionDetilDialog />
        </Container>
      )}
      {dialogType === "connectionsuccess" && (
        <Container maxWidth="false" disableGutters>
          <SuccessDialog
            headtext={t(ConnectionsToken.ConnectionRequestSentDialogTitle)}
            bodytext={t(ConnectionsToken.ConnectionRequestSentDialogMessage,{0:getFirstName()})}
          />
        </Container>
      )}
    </ScrollContainerWrapper>
  );
};

export default SearchList;
